import { render, staticRenderFns } from "./EmptyInvoice.vue?vue&type=template&id=4ad149e4&scoped=true"
import script from "./EmptyInvoice.vue?vue&type=script&lang=ts"
export * from "./EmptyInvoice.vue?vue&type=script&lang=ts"
import style0 from "./EmptyInvoice.vue?vue&type=style&index=0&id=4ad149e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad149e4",
  null
  
)

export default component.exports